/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Component, Input, OnInit, inject} from '@angular/core';

import {FormFieldAttribute} from '../../../../../models/FormCategory';
import {GeneralDataHandlingService} from '../../../../../services/general.data-handling.service';
import {IxModule} from '@siemens/ix-angular';
import {PassportDto} from '../../../../../models/Passport';

@Component({
  selector: 'app-address',
  imports: [IxModule],
  templateUrl: './address.component.html',
  styleUrl: './address.component.scss',
})
export class AddressComponent implements OnInit {
  private readonly dataHandler = inject(GeneralDataHandlingService);

  @Input({required: true}) attribute!: FormFieldAttribute;
  @Input({required: true}) passport!: PassportDto['data'];

  addressValue = '';

  ngOnInit() {
    this.addressValue = this.getAddress();
  }

  assignSpecialFields(
    streetField: null | string,
    numberField: null | string,
    nameField: null | string,
    addressValues: string[],
  ) {
    if (streetField || numberField) {
      addressValues.unshift(`${streetField ?? ''} ${numberField ?? ''}`.trim());
    }
    if (nameField) {
      addressValues.unshift(nameField);
    }
    return addressValues;
  }

  private getAddress(): string {
    let streetField: string | null = null;
    let numberField: string | null = null;
    let nameField: string | null = null;
    const addressValues = [];
    for (const subAttribute of this.attribute.attributes || []) {
      const value = this.dataHandler.getValueByPath(
        this.passport,
        `${this.attribute.valuePath}.${subAttribute.valuePath}`,
      );
      if (value) {
        const normalizedPath = this.normalizePath(subAttribute.valuePath);
        if (this.isContactNamePath(normalizedPath)) {
          nameField = value;
        } else if (this.isStreetPath(normalizedPath)) {
          streetField = value;
        } else if (this.isAddressNumberPath(normalizedPath)) {
          numberField = value;
        } else {
          addressValues.push(value);
        }
      }
    }
    this.assignSpecialFields(
      streetField,
      numberField,
      nameField,
      addressValues,
    );
    return addressValues.join(', ');
  }

  private normalizePath(valuePath: string): string {
    return valuePath.replace(/\[\d+]/g, '').toLowerCase();
  }

  private isContactNamePath(path: string): boolean {
    return path.endsWith('contactname');
  }

  private isStreetPath(path: string): boolean {
    return path.endsWith('street') || path.endsWith('streetname');
  }

  private isAddressNumberPath(path: string): boolean {
    return path.endsWith('number') || path.endsWith('addressnumber');
  }
}
